const wowApp = require('angular').module('wowApp.common');

wowApp.directive('olyStickyHeaderWithImage', ['$state', 'RetinaDetectionService', require('./sticky-header-with-image-directive')]);
wowApp.directive('olyStickyHeaderWithText', ['$state', require('./sticky-header-with-text-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/sticky-header/index.js
 **/